<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <v-snackbar v-model="showsnackbar" color="primary" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 md12 pa-0>
        <v-card id="app_height" outlined tile>
          <v-layout wrap justify-space-around>
            <v-flex xs12 md12 pa-8>
              <v-layout wrap>
                <v-flex xs12 md12 text-center>
                  <span style="font-size:20px;font-weight:500;">Contact Us List</span>
                </v-flex>
              </v-layout>
              <v-layout wrap px-2 justify-center>
                <v-flex xs12 md12>
                  <v-card-title>
                    <v-layout wrap justify-space-around>
                      <!-- <v-flex xs4 sm4 md4 px-2>
                        <v-select :items="statusfilter" label="Status " @change="filterAuthor"></v-select>
                      </v-flex> -->
                      <v-flex xs6 sm4 md4 px-2>
                        <!-- <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          color="#26af82"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field> -->
                      </v-flex>
                    </v-layout>
                  </v-card-title>

                  <v-data-table
                    :headers="headers"
                    dense
                    :items="Queries"
                    :search="search"
                    :sort-desc="[false, true]"
                    color="#26af82"
                    :loading="appLoading"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                  >
                    <template v-slot:item._id="{ item }">
                      <router-link tag='span' :to="'/ViewContactUs/'+item._id">
                        <v-btn v-if="item.status == 'read'" small text color="success" block>View</v-btn>
                         <v-btn v-else small text color="red" block>View</v-btn>
                      </router-link>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";
export default {
  components: {
    VueElementLoading
  },
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 10000,
      msg: null,
      search: null,
      statusfilter: ["Read", "Unread", "Replied"],
      headers: [
        // { text: "Status", value: "status" },
        { text: "Date", value: "createddate" },
        { text: "Name", value: "name" },
        { text: "Email Id", value: "email" },
        { text: "Phone", value: "ph" },
        { text: "Action", align: "center", value: "_id" }
      ],
      Queries: []
    };
  },
  beforeMount() {
    this.getList();
  },
  methods: {
    getList() {
      this.appLoading = true;
      var data = {};
     

      axios({
        method: "POST",
        url: "/contactus/all/list",
        headers: {
          token: localStorage.getItem("token")
        },
        data: data
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
            this.Queries = response.data.data;
            for (var i = 0; i < this.Queries.length; i++) {
              var dt = new Date(this.Queries[i].create_date);
              dt = dt.toString();
              dt = dt.slice(4, 25);
              this.Queries[i].createddate = dt;
            }
          } else {
            this.msg = response.data.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch(err => {
          this.appLoading = false;
          this.msg = err.response.msg;
          this.showsnackbar = true;
        });
    }
  }
};
</script>
<style>
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
    min-width: 80vw;
  }
}
</style>